import { createTheme } from '@mui/material';

export const customTheme = createTheme({
  typography: {
    fontFamily: ['Montserrat', 'sans-serif'].join(','),
  },
});
